import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Source from "../../Source";
import { showAlert } from "../../warrper";
import Reset from "../settings/Reset";
import AddInfo from "../forms/AddInfo";
import AddDatabaseform from "../forms/AddDatabase";
import { useSelector, useDispatch } from "react-redux";
import { getSettings, updateSettingInCache } from "../Redux/settingSlice";
import { FormattedMessage } from "react-intl";
import { useShowAlert  } from "../../warrper";
import SidebarShow from '../forms/SidebarShow'
const transformOptions = (optionsObj) => {
  return Object.keys(optionsObj).map(key => ({
    id: key,
    label: key,
    checked: optionsObj[key] === 1
  }));
};
export default function Sideoption() {
  const showAlert = useShowAlert(); 
  const [showPopupReset, setShowPopupReset] = useState(false);
  const [AddinfoModel, setAddinfoModel] = useState(false);
  const [AddDatabase, setAddDatabase] = useState(false);
  const { settings, statuss } = useSelector((state) => state.settings);
  const dispatch = useDispatch();
  const [SidebarModel,setSidebarModel]=useState(false);
  const [Settings, Setsettings] = useState([]);
  const { sidebars } = useSelector((state) => state.sidebars);
  useEffect(() => {
    if (statuss === null ) {
      dispatch(getSettings());
    }
  }, []);

  useEffect(() => {
    if (settings.length > 0) {
      Setsettings(settings);
    }
  }, []);

  const handle = (e) => {
    if (Settings.length === 0) return;

    const updatedSettings = { ...Settings[0], [e.target.name]: e.target.value };
    Setsettings([updatedSettings]);
    localStorage.setItem(e.target.name, e.target.value);

    const uploadData = new FormData();
    uploadData.append("_method", "PUT");
    uploadData.append("date", updatedSettings.date);
    uploadData.append("language", updatedSettings.language);

    axios
      .post(`${Source.getAddress()}/api/settings/${Settings[0]?.id}`, uploadData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      })
      .then((res) => {
        dispatch(updateSettingInCache(res.data.settings));
        Setsettings([res.data.settings]);
        showAlert({
          position: "top-end",
          icon: "success",
          title: "Settings updated successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch(() => {
        showAlert({
          position: "top-end",
          icon: "error",
          title: "Something went wrong!",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };
  const handleBackup = async () => {
    try {
        const response = await axios.get(Source.getAddress()+'/api/backup', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
            responseType: 'blob', // برای دریافت فایل
        });
        // ایجاد لینک دانلود
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'backup.sql'); // نام فایل دانلودی
        document.body.appendChild(link);
        link.click();

        // حذف لینک
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error during backup:', error);
        alert('Failed to create backup.');
    }
  }
const handleDatabase=()=>{
setAddDatabase(true);
}
  return (
    <div 
    dir={localStorage.getItem("language") === "en" ? "ltr" : "rtl"}
    className="popup-container mx-auto" style={{ width: "40%" }}>
      <div className="container bg-light mt-5" style={{ borderTop: "5px solid #4a5cf2" }}>
        <h2 className="m-2 fw-bold mb-4 w-100"><FormattedMessage id="Settings"/></h2>
        <div className="table-responsive">
          <table className="table table-light table-striped">
            <tbody>
              {Settings.length > 0 ? (
                <>
                  {/* <tr>
                    <td>
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        <strong className="fs-5 p-1 me-5"><FormattedMessage id="Date"/></strong>
                        <select
                          name="date"
                          onChange={handle}
                          className="form-select h-50 ms-2 me-2 w-50 w-md-30"
                          value={Settings[0]?.date || ""}
                        >
                          <option value="English"><FormattedMessage id="English"/></option>
                          <option value="Persian"><FormattedMessage id="Dari"/></option>
                          <option value="Persian"><FormattedMessage id="Pashto"/></option>
                        </select>
                      </div>
                    </td>
                  </tr> */}
                  {/* <tr>
                    <td>
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        <strong className="fs-5 p-1 me-5"><FormattedMessage id="Language"/></strong>
                        <select
                          name="language"
                          onChange={handle}
                          className="form-select h-50 ms-2 me-2 w-50 w-md-30"
                          value={Settings[0]?.language || ""}
                        >
                          <option value="en"><FormattedMessage id="English"/></option>
                          <option value="da"><FormattedMessage id="Dari"/></option>
                          <option value="pa"><FormattedMessage id="Pashto"/></option>
                        </select>
                      </div>
                    </td>
                  </tr> */}
                  <tr>
                    <td>
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        <strong className="fs-5 p-1 me-5"><FormattedMessage id="Reset To Default"/></strong>
                        <button
                          onClick={() => setShowPopupReset(true)}
                          type="button"
                          className="btn btn-outline-danger fw-bold m-2 me-3  w-md-auto"
                        >
                          <FormattedMessage id="Reset"/>
                        </button>
                      </div>
                    </td>
                  </tr>
                  {/* <tr>
                    <td>
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        <strong className="fs-5 p-1 me-5"><FormattedMessage id="Get Backup"/></strong>
                        <button
                          onClick={() => handleBackup()}
                          type="button"
                          className="btn btn-outline-primary fw-bold m-2 me-3  w-md-auto"
                        >
                          <FormattedMessage id="Backup"/>
                        </button>
                      </div>
                    </td>
                  </tr> */}
                  <tr>
                    <td>
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        <strong className="fs-5 p-1 me-5"><FormattedMessage id="Upload Databse"/></strong>
                        <button
                          onClick={() => handleDatabase()}
                          type="button"
                          className="btn btn-outline-primary fw-bold m-2 me-3  w-md-auto"
                        >
                          <FormattedMessage id="Upload Databse"/>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        <strong className="fs-5 p-1 me-5"><FormattedMessage id="Sidebar Option"/></strong>
                        <button     
                          onClick={() => setSidebarModel(true)}
                          type="button"
                          className="btn btn-outline-primary fw-bold m-2 me-3  w-md-auto"
                        >
                          <FormattedMessage id="Change"/>
                        </button>
                      </div>
                    </td>
                  </tr>
                  {/* <tr>
                    <td>
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        <strong className="fs-5 p-1"><FormattedMessage id="Organisation Info"/></strong>
                        <button
                          onClick={() => setAddinfoModel(true)}
                          type="button"
                          className="btn btn-outline-success fw-bold m-2 me-3 w-md-auto"
                        >
                          <FormattedMessage id="Change"/>
                        </button>
                      </div>
                      <div className="ps-2 d-flex flex-column flex-md-row justify-content-between align-items-center">
  <div className="mt-3 w-100">
    <div className="m-2">
      <p className="fw-bold"><FormattedMessage id="Company Name"/>: {Settings[0]?.company_name || "N/A"}</p>
      <p className="fw-bold"><FormattedMessage id="Address"/>: {Settings[0]?.address || "N/A"}</p>
      <p className="fw-bold"><FormattedMessage id="Phone"/>: {Settings[0]?.phone || "N/A"}</p>
      <p className="fw-bold"><FormattedMessage id="Email"/>: {Settings[0]?.email || "N/A"}</p>
      <p><FormattedMessage id="Description"/>: {Settings[0]?.description || "N/A"}</p>
    </div>
  </div>
  <div style={{ width: "150px", height: "150px" }} className="mt-3">
    <img
      className="td_img rounded"
      src={settings[0].company_pic}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        outline: "2px solid aliceblue",
      }}
      alt="Company"
    />
  </div>
</div>

                    </td>
                  </tr> */}
                </>
              ) : (
                <tr>
                  <td className="text-center"><FormattedMessage id="Loading..."/></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <SidebarShow close={()=>setSidebarModel(false)} SidebarModel={SidebarModel} options={transformOptions(sidebars[0])}/>
      <Reset addAccountModal={showPopupReset} close={() => setShowPopupReset(false)} />
      <AddInfo settings={Settings} setsettings={Setsettings} close={() => setAddinfoModel(false)} addAccountModal={AddinfoModel} />
      <AddDatabaseform setsettings={Setsettings} settings={Settings} close={() => setAddDatabase(false)} addAccountModal={AddDatabase}/>
    </div>
  );
}